import * as React from "react";
import { ToolTipButton } from "nsitools-react";
import { IconNames } from "@blueprintjs/icons";
import { ETLCodes } from "../../locales";
import { useTl } from "../../hooks";
import { ICustomButtonProps } from "./ICustomButtonProps";
import { Intent } from "@blueprintjs/core";
import { useAuth } from "../../contexts";

interface IEditButtonProps extends ICustomButtonProps {
  secured?: boolean;
}

export const EditButton: React.FunctionComponent<IEditButtonProps> = ({
  minimal = true,
  onClick,
  loading,
  disabled,
  intent = Intent.NONE,
  text,
  secured = true,
}) => {
  const { t } = useTl();
  const { getCurrentPermission } = useAuth();
  const hasRights = React.useMemo(() => getCurrentPermission()?.permission.includes("RW"), [getCurrentPermission]);

  return (
    <ToolTipButton
      icon={IconNames.EDIT}
      tooltip={text ? null : t(ETLCodes.General_Edit)}
      minimal={minimal}
      onClick={onClick}
      text={text ? text : minimal ? null : t(ETLCodes.General_Edit)}
      intent={intent}
      loading={loading}
      disabled={disabled || (secured && !hasRights)}
    />
  );
};
